<svelte:options tag={null} />
<script>
  import { get_current_component } from "svelte/internal";
  import "@everymatrix/em-accordion";

  export let success = false;
  export let error;
  export let rules;
  let selectedRuleId;
  let selectedTransType;
  
  const thisComponent = get_current_component();

  const dispatchWcEvent = (name, detail) => {
    thisComponent.dispatchEvent(
      new CustomEvent(name, {
        detail,
        composed: true, // propagate across the shadow DOM
      })
    );
  };

  const handleData = (rule, type) => {
    // Send Custom Event
    dispatchWcEvent("change", { limitRuleId: rule,  transType: type });
  };

  $: console.log('===success', success);
</script>


<!-- Transaction Limit -->
{#if rules}
  <label class="selectWrapper">
    <span>Select Limit</span>
    <select bind:value="{selectedRuleId}">
      {#each rules as rule}
        <option value={rule.id}>
          {rule.name}
        </option>
      {/each}
    </select>
  </label>

<!-- Transaction Type -->
  <label class="selectWrapper">
    <span>Transaction type</span>
    <select bind:value="{selectedTransType}">
      <option value="Deposit">Deposit</option>
      <option value="Withdraw">Withdraw</option>
      <option value="Transfer">Transfer</option>
      <option value="User2User">User2User</option>
      <option value="Vendor2User">Vendor2User</option>
      <option value="User2Vendor">User2Vendor</option>
      <option value="User2Agent">User2Agent</option>
      <option value="Agent2User">Agent2User</option>
      <option value="Refund">Vendor2User via API</option>
      <option value="Reversal">User2Vendor via API</option>
    </select>
  </label>
  
  {#if success?.hasOwnProperty('limitRuleId')}
    <p style="color: green;">
      Limit saved succesfully
    </p>
  {/if}
  {#if error && error.includes('limitRule')}
    <p style="color: red;">
      {error}
    </p>
  {:else if error && error.includes('GmRest')}
    <p style="color: red;">
      {error.slice(0, 23)}
    </p>
  {/if}
  <!-- Save Button -->
  <button
    class="button" 
    on:click={() => handleData(selectedRuleId, selectedTransType)}
  >
    Save
  </button>
{:else}
  <p style="color: red; font-size: 14px;">
    Something went wrong, try again later
  </p>
{/if}


<style lang="scss">
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    list-style: none;
    outline: none;
    text-decoration: none;
    box-sizing: border-box;
    font-family: "Helvetica Neue", "Helvetica", sans-serif;
  }
  .accordion {
    margin-bottom: 10px;

    &__content {
      display: flex;
      flex-direction: column;
    }
  }

  .selectWrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    font-weight: bold;
    cursor: pointer;
    span {
      margin-bottom: 20px;
      font-size: 12px;
    }
    select {
      padding: 10px;
    }
  }

  .button {
    display: block;
    width: 150px;
    margin: 20px auto 0 auto;
    min-height: 30px;
    padding: 6px 7px;
    color: #fff;
    background: #307fe2;
    border: 1px solid #307fe2;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 16px;
    &:hover {
      background: #000;
      border: 1px solid #000;
    }
  }
</style>
